import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useRemoteClientPost } from '../../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../../remote/local-storage'

export const LoadCategoryProduct = () => {
  const [params] = useSearchParams()
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const { getUnitId } = useLocalStorage()

  const { httpClientPost } = useRemoteClientPost()

  const load = () => {
    if (!loading) {
      setLoading(true)
      httpClientPost(`/categoria-produto/filtro?page=${params.get('page') || 0}&size=10`, {
        unidade: {
          id: getUnitId()
        }
      })
        .then((response) => {
          setData(
            response.data.data.content.map((item: any) => ({
              ...item,
              label: item.descricao,
              value: item.id
            }))
          )
        })
        .catch(CatchMessageError)
        .finally(() => setLoading(false))
    }
  }

  useEffect(() => {
    load()
  }, [params])

  return {
    data
  }
}
